export function formatDisplayPhoneNumber(value: string | null | undefined): string | null {
  const phone = value?.trim();
  if (!phone) return null;
  if (!/^[+\d\s()-]+$/.test(phone)) return phone;

  const digits = phone.replace(/\D/g, '');
  const local = /^[78]\d{10}$/.test(digits)
    ? digits.slice(1)
    : /^9\d{9}$/.test(digits) && !phone.startsWith('+') ? digits : null;
  if (local) return `+7 ${local.slice(0, 3)} ${local.slice(3, 6)} ${local.slice(6, 8)} ${local.slice(8)}`;
  if (/^375\d{9}$/.test(digits)) {
    const national = digits.slice(3);
    return `+375 ${national.slice(0, 2)} ${national.slice(2, 5)} ${national.slice(5, 7)} ${national.slice(7)}`;
  }
  return phone;
}